import { getAdminApiUrl } from '@adsk/acs-sc-web-platform-api';
import iso3166 from 'iso-3166-2';

export const massageAPIFields = (newData, oldData) => ({
  name: newData.name,
  type: newData.type,
  ...(newData.addressLine1 !== oldData.addressLine1 && {
    addressLine1: newData.addressLine1,
  }),
  ...(newData.addressLine2 !== oldData.addressLine2 && {
    addressLine2: newData.addressLine2,
  }),
  ...(newData.city !== oldData.city && { city: newData.city }),
  ...(newData.stateOrProvince !== oldData.stateOrProvince && {
    stateOrProvince: newData.stateOrProvince,
  }),
  ...(newData.postalCode !== oldData.postalCode && {
    postalCode: newData.postalCode,
  }),
  ...(newData.country !== oldData.country && { country: newData.country }),
  ...(newData.timezone !== oldData.timezone && { timezone: newData.timezone }),
  ...(newData.jobNumber !== oldData.jobNumber && {
    jobNumber: newData.jobNumber ? newData.jobNumber : '',
  }),
  ...(newData.startDate !== oldData.startDate && {
    startDate: newData.startDate,
  }),
  ...(newData.endDate !== oldData.endDate && { endDate: newData.endDate }),
  ...((newData.projectValue?.value?.toString() !==
    oldData.projectValue?.value?.toString() ||
    newData.projectValue?.currency !== oldData.projectValue?.currency) && {
    projectValue: {
      currency: newData.projectValue.currency,
      value: newData.projectValue?.value
        ? parseFloat(newData.projectValue.value)
        : 0,
    },
  }),
});

// TODO: Change to store utils ??
export const computeProjectDataChanged = (data1, data2) =>
  data1.name !== data2.name ||
  data1.type !== data2.type ||
  data1.addressLine1 !== data2.addressLine1 ||
  data1.addressLine2 !== data2.addressLine2 ||
  data1.city !== data2.city ||
  data1.stateOrProvince !== data2.stateOrProvince ||
  data1.postalCode !== data2.postalCode ||
  data1.country !== data2.country ||
  data1.timezone !== data2.timezone ||
  data1.jobNumber !== data2.jobNumber ||
  data1.startDate !== data2.startDate ||
  data1.endDate !== data2.endDate ||
  data1.projectValue?.value?.toString() !==
    data2.projectValue?.value?.toString() ||
  data1.projectValue?.currency !== data2.projectValue?.currency;

export const isDuplicateNameError = (errors = []) => {
  const re = /^name:.+\sunique validation failed/i;

  return errors.some(
    (error) => error.field === 'name' && re.test(error.detail)
  );
};

export const buildEditProjectRequest = (projectId, projectData) => [
  `${getAdminApiUrl()}/v1/projects/${projectId}`,
  {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(projectData),
  },
];

export const computeDateDiffDays = (date, diff) => {
  if (date && diff != null) {
    const result = new Date(date.getTime());
    result.setDate(date.getDate() + diff);

    return result;
  }

  return null;
};

export const createDateFromISOString = (string) => {
  if (string) {
    return new Date(`${string}T00:00:00`);
  }

  return null;
};

export const validProjectValue = (value) => {
  const regInteger = /^-?\d*(\.\d+)?$/;

  return value !== '' ? regInteger.test(value) : true;
};

export const getCountryStateNames = (countryCode, stateCode) => {
  let countryName = countryCode;
  let stateName = stateCode;
  const countryInfo = iso3166.data[countryCode];

  if (countryCode && countryCode !== '' && countryInfo) {
    countryName = countryInfo.name;
    const stateKey = `${countryCode}-${stateCode}`;
    if (stateCode && stateCode !== '' && countryInfo.sub[stateKey]) {
      stateName = countryInfo.sub[stateKey].name;
    }
  }

  return { countryName, stateName };
};
